.root {
  font-weight: 400;
  border: 1px solid transparent;
  color: var(--tag-text-color);
  --pill-height: auto;
  --pill-radius: var(--adl-tag-radius);
}

.label {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 2px;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--tag-dot-color);
  flex-shrink: 0;
  margin: 2px 0 2px 2px;
}

/* Size variants */
.condensed {
  padding: 2px 4px;
}

.standard {
  padding: 4px;
}

.expanded {
  padding: 6px 4px;
}

/* Solid variant */
.solid.info {
  background: var(--adl-tag-info-solid-bg);
  --tag-text-color: var(--adl-tag-info-text);
}
.solid.success {
  background: var(--adl-tag-success-solid-bg);
  --tag-text-color: var(--adl-tag-success-text);
}
.solid.warning {
  background: var(--adl-tag-warning-solid-bg);
  --tag-text-color: var(--adl-tag-warning-text);
}
.solid.alert {
  background: var(--adl-tag-alert-solid-bg);
  --tag-text-color: var(--adl-tag-alert-text);
}
.solid.neutral {
  background: var(--adl-tag-neutral-solid-bg);
  --tag-text-color: var(--adl-tag-neutral-text);
}
.solid.light {
  background: var(--adl-tag-light-solid-bg);
  --tag-text-color: var(--adl-tag-light-text);
}

/* Outline variant */
.outline.info {
  background: var(--adl-tag-info-outline-bg);
  border-color: var(--adl-tag-info-border);
  --tag-dot-color: var(--adl-tag-info-dot);
  --tag-text-color: var(--adl-tag-info-text);
}
.outline.success {
  background: var(--adl-tag-success-outline-bg);
  border-color: var(--adl-tag-success-border);
  --tag-dot-color: var(--adl-tag-success-dot);
  --tag-text-color: var(--adl-tag-success-text);
}
.outline.warning {
  background: var(--adl-tag-warning-outline-bg);
  border-color: var(--adl-tag-warning-border);
  --tag-dot-color: var(--adl-tag-warning-dot);
  --tag-text-color: var(--adl-tag-warning-text);
}
.outline.alert {
  background: var(--adl-tag-alert-outline-bg);
  border-color: var(--adl-tag-alert-border);
  --tag-dot-color: var(--adl-tag-alert-dot);
  --tag-text-color: var(--adl-tag-alert-text);
}
.outline.neutral {
  background: var(--adl-tag-neutral-outline-bg);
  border-color: var(--adl-tag-neutral-border);
  --tag-dot-color: var(--adl-tag-neutral-dot);
  --tag-text-color: var(--adl-tag-neutral-text);
}
.outline.light {
  background: var(--adl-tag-light-outline-bg);
  border-color: var(--adl-tag-light-border);
  --tag-dot-color: var(--adl-tag-light-dot);
  --tag-text-color: var(--adl-tag-light-text);
}
